var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.995 15.8581C11.7133 15.1226 12.4316 14.3871 13.1531 13.6532C14.2925 12.4927 15.4319 11.3307 16.5775 10.1765C17.0466 9.70605 17.6473 9.60098 18.1798 9.86601C18.7604 10.1561 19.0963 10.7128 18.9755 11.337C18.9167 11.6381 18.7665 11.969 18.556 12.1854C15.9056 14.8968 13.2413 17.5957 10.5693 20.2867C9.84473 21.0159 9.14188 21.0065 8.42356 20.2836C5.77008 17.6082 3.12125 14.9297 0.470866 12.2497C0.0606142 11.8357 -0.109679 11.3448 0.0729991 10.7677C0.251033 10.2047 0.630321 9.84876 1.20932 9.74839C1.73568 9.65744 2.14593 9.8958 2.51129 10.2643C4.26066 12.0348 6.01778 13.7959 7.7687 15.5649C7.85849 15.6542 7.91577 15.7781 7.98853 15.8848C8.03033 15.8581 8.07213 15.833 8.11393 15.8064C8.11393 15.6684 8.11393 15.5304 8.11393 15.3924C8.11393 9.22775 8.11703 7.76932 8.10774 1.60472C8.10774 0.969596 8.3028 0.480317 8.86322 0.165109C9.7085 -0.313193 10.8355 0.304679 10.9036 1.28637C10.9145 1.44163 10.9098 1.59845 10.9098 1.75527C10.9098 7.8838 10.9098 9.30773 10.9098 15.4363C10.9098 15.5649 10.9098 15.695 10.9098 15.8236C10.9393 15.8314 10.9671 15.844 10.995 15.8581Z",
    fill: "#414143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/downArrowIcon.dad7c3fcebddd96abf3cb1c2e43a04d8.svg";
export { ForwardRef as ReactComponent };